// maybe to refactor some day into one popup component, though I'm not sure it makes sense
angular.module(NgAppName).component('crOffMarketPopup', {
  templateUrl: 'crOffMarketPopup.html',
  bindings: {
    rpcRegisterContact: '@',
    rpcSmartmatch: '@'
  },
  controller: ['$scope', '$timeout', '$interval', '$window', "$cookies", '$rootScope', "patterns", 'PubSub', '$element', '$document', 'crResourcesService',
    function($scope, $timeout, $interval, $window, $cookies, $rootScope, patterns, PubSub, $element, $document, crResourcesService) {
      let ctrl = this;
			let popupChild;
			

      this.user = null;
      this.rpc = null;
      this.isTownhouse = false;
      this.isHouse = false;

      this.showDisclaimer = false;
      this.showForm = false;

      this.formData = {
        buyerRenter: 0,
        dayphone: null,
        email: null,
        name: null,
        msg: null,
        // multisteps: false,
        // stepNum: 3,
        // type: 'json',
        beds: [],
        viewed: false,
        isLoading: false,
        // version: "off-market-deals",
        // popup: "entry",
        // popupName: "popup-in-entry",
        // source: "building",
        offMktTextVersion: null
      };

      this.customFormValidation = {
        bedsError: false,
        commentsError: false,
        firstSubmitAttempt: 0,
        thankYouStep: false
      };

			this.smartMatchToken = null;
			this.usrRegisterStatus = false;
      this.autoUsrToken = null;

			this.patterns = patterns;

      // move this component to the body and set up event listeners
      this.$onInit = function() {
        let bodyChildren = Array.from(document.body.children);
        let existingInBody = bodyChildren.find(function(child) {
          return child.tagName.toLowerCase() === 'cr-off-market-popup';
        });

        if (!existingInBody) {
          // Move the component to the body
          angular.element(document.body).append($element);
          popupChild = $element[0].querySelector('.cr-off-market-popup');

          // hide on overlay click
          angular.element(popupChild).on('click', function(event) {
            var popupBlock = $element[0].querySelector('.popup-block');
            var closeButton = $element[0].querySelector('.close');
            
            if (popupBlock && !popupBlock.contains(event.target)) {
              angular.element(popupChild).removeClass('visible');
            }

            if (closeButton && closeButton.contains(event.target)) {
              angular.element(popupChild).removeClass('visible');
            }
          });
        } else {
          // removing others, as we need only one
          $element.remove();
        }

        $rootScope.$on('openOffMarketPopup', function (event, data) {
          if (popupChild) {
            $timeout(function() {
							
              ctrl.showForm = false;
              ctrl.customFormValidation = {
                bedsError: false,
                commentsError: false,
                firstSubmitAttempt: 0,
                thankYouStep: false
              };
              ctrl.user = data.user;
              ctrl.buildingName = data.buildingName;
              ctrl.buildingToken = data.buildingToken;
              ctrl.listingToken = data.listingToken;
              ctrl.rpc = data.rpc;
              ctrl.isTownhouse = data.isTownhouse;
              ctrl.isHouse = data.isHouse;
              ctrl.formData.name = ctrl.user.name;
              ctrl.formData.email = ctrl.user.email;
              ctrl.formData.dayphone = ctrl.user.phone;
              ctrl.formData.offMktTextVersion = data.offMktTextVersion;
							
              $scope.$apply();

              angular.element(popupChild).addClass('visible');
            });
          }
        });
      };


      this.beds = ['Studio', '1 Bed', '2 Beds', ' 3 Beds', '4+ Beds'];

      this.toggleBedsSelection = function(beds) {
        const index = ctrl.formData.beds.indexOf(beds);
        if (index > -1) {
          ctrl.formData.beds.splice(index, 1);
        } else {
          ctrl.formData.beds.push(beds);
        }
      };
      
      ctrl.submitForm = function (form) {
        ctrl.formData.isLoading = true;

        if (!ctrl.showForm) {
          if (ctrl.formData.beds.length == 0) {
            ctrl.customFormValidation.bedsError = true;
            ctrl.formData.isLoading = false;
            return;
          } else {
            ctrl.customFormValidation.bedsError = false;
          }
          ctrl.showForm = true;
          ctrl.formData.isLoading = false;
          return false;
        }

        if (ctrl.formData.beds.length === 0) {
          ctrl.formData.isLoading = false;
          return;
        }
        

        if (form.$valid) {
          window.crRecaptcha.execute(() => {

            if (ctrl.customFormValidation.firstSubmitAttempt < 2) {
              ctrl.customFormValidation.firstSubmitAttempt++;

              if (!ctrl.formData.msg || ctrl.formData.msg.trim() === '') {
                ctrl.customFormValidation.commentsError = true;
              }
            }

            ctrl.submitFormData(form);
          });
        } else {
          form.$setSubmitted();
          ctrl.formData.isLoading = false;
        }
      };


      ctrl.submitFormData = function(form) {
        ctrl.formData.reCaptchaTokens = window.crRecaptcha.getTokens();
        ctrl.formData.popup = "bldg-navbar";
        if (ctrl.buildingToken) {
          ctrl.formData.buildingToken = ctrl.buildingToken;
          ctrl.formData.source = "building";
        }
        if (ctrl.listingToken) {
          ctrl.formData.popup = "callout-off-market-deals";
          ctrl.formData.listingToken = ctrl.listingToken;
          ctrl.formData.source = "listing-sale";
          ctrl.formData.version = "off-market-deals";
        }
        let crDataPromise = crResourcesService.post(ctrl.rpc,  ctrl.formData);
        crDataPromise
          .then(function(data) {
            if (data["RPCFormReusableContact_FORMSUMMARY"][0].status) {
              ctrl.formData.token = data["RPCFormReusableContact_FORMSUMMARY"][0].token;
              if (ctrl.customFormValidation.firstSubmitAttempt >= 2 || ctrl.formData.msg) {
                ctrl.customFormValidation.thankYouMessage = data["RPCFormReusableContact_FORMSUMMARY"][0].message;
                ctrl.customFormValidation.thankYouStep = true;

                if (typeof data["RPCFormReusableContact_FORMSUMMARY"][0].autoUsrToken !== "undefined") {
                  ctrl.autoUsrToken = data["RPCFormReusableContact_FORMSUMMARY"][0].autoUsrToken;
                } else {
                  ctrl.autoUsrToken = null;
                }

                if (typeof data["RPCFormReusableContact_FORMSUMMARY"][0].smartMatchToken !== "undefined") {
                  ctrl.smartMatchToken = data["RPCFormReusableContact_FORMSUMMARY"][0].smartMatchToken;
                } else {
                  ctrl.smartMatchToken = null;
                }

              }
            } else {
              if (data["RPCFormReusableContact_name"]) {
                let error = data["RPCFormReusableContact_name"];
                form.name.$setValidity("pattern", false);
                form.name.customErrorMessage = error[0];
              }
              if (data["RPCFormReusableContact_dayphone"]) {
                let error = data["RPCFormReusableContact_dayphone"];
                form.phone.$setValidity("pattern", false);  // Set phone as invalid
                form.phone.customErrorMessage = error[0]; // Store the custom error message for phone
              }
              if (data["RPCFormReusableContact_email"]) {
                let error = data["RPCFormReusableContact_email"];
                form.email.$setValidity("pattern", false);
                form.email.customErrorMessage = error[0];
              }
            }
            ctrl.formData.isLoading = false;
          })
          .catch(function(error) {
            ctrl.formData.isLoading = false;
            console.error('An error occurred:', error);
          });
      };

      ///yesEmailTheListings

      this.yesEmailTheListings = () => {
        ctrl.formData.isLoading = true;
        this.usrRegisterStatus = false;
        this.usrRegisterMessage = "";
        
        var input = {
          autoUsrToken: this.autoUsrToken
        };

        if (this.buildingToken) {
          input.buildingToken = this.buildingToken;
        }
        if (this.listingToken) {
          input.listingToken = this.listingToken;
        }

        var crDataPromise = crResourcesService.post(this.rpcRegisterContact, input);
        crDataPromise.then((data) => {
          if (typeof data.status !== "undefined") {
            this.usrRegisterStatus = data.status;
          }
          if (typeof data.message !== "undefined") {
            this.usrRegisterMessage = data.message;
          }
        }).finally(() => {
          ctrl.formData.isLoading = false;
        });
      };

      this.subscribeSmartMatch2 = () => {
        ctrl.formData.isLoading = true;
        this.usrRegisterStatus = true;
        this.usrRegisterMessage = "";
        this.reloadCounter = null;

        var input = {
          smartMatchToken: this.smartMatchToken
        };

        var crDataPromise = crResourcesService.post(this.rpcSmartmatch, input);
        crDataPromise.then((data) => {
          
        }).finally(() => {
          ctrl.formData.isLoading = false;
        });
      };

      this.canRegister = () => {
        return this.autoUsrToken && this.rpcRegisterContact;
      };
      
      this.closeTheForm = () => {
        if (popupChild) {
          angular.element(popupChild).removeClass('visible');
        }
      };

    }
  ]
});

// External button click handler that triggers the AngularJS event
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    let target = event.target.closest('.off-market-open'); // Find the closest element with this class
    if (target) {
      // Only proceed if the click was on a .contact-v2-open button
      let rpc = target.getAttribute('data-rpc');
      let buildingToken = target.getAttribute('data-building-token');
      let listingToken = target.getAttribute('data-listing-token');
      let userData = JSON.parse(target.getAttribute('data-user'));
      let buildingName = target.getAttribute('data-building-name');
      let isTownhouse = target.getAttribute('data-is-townhouse');
      let isHouse = target.getAttribute('data-is-house');
      let offMktTextVersion = target.getAttribute('data-text-version');

      // Trigger AngularJS event
      let injector = angular.element(document.body).injector();
      let rootScope = injector.get('$rootScope');

      rootScope.$apply(function() {
				rootScope.$broadcast('openOffMarketPopup', {
					user: userData,
					buildingName: buildingName,
          buildingToken: buildingToken,
          listingToken: listingToken,
          rpc: rpc,
          isTownhouse: isTownhouse,
          isHouse: isHouse,
          offMktTextVersion: offMktTextVersion
        });
      });
    }
  });
});
